if (!customElements.get('arn-product-gallery-pagination')) {
    class ArnProductGalleryPagination extends HTMLElement {
        constructor() {
            super();
            this.swiper = this.closest('arn-swiper');
            this.currentSlideEl = this.querySelector("[data-current-slide]");

            if (!this.currentSlideEl) {
                console.error('arn-product-gallery-pagination must contain an element with dataset "data-current-slide"');
                return;
            }

            if (!this.swiper) {
                console.error('arn-product-gallery-pagination must be a child of arn-swiper');
                return;
            }
        }

        connectedCallback() {
            this.swiper.addEventListener('slideChanged', (event) => {
                this.currentSlideEl.innerText = event.detail.activeIndex + 1;
            });
        }
    }
    customElements.define("arn-product-gallery-pagination", ArnProductGalleryPagination);
}